"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOI_DERIVATION_BASE_PATH = exports.MOI_DERIVATION_PATH = void 0;
exports.MOI_DERIVATION_PATH = "m/44'/6174'/0'/0/0";
exports.MOI_DERIVATION_BASE_PATH = "m/44'/6174'/0'/0";
